
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist/[pid]/press",
      function () {
        return require("private-next-pages/artist/[pid]/press.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist/[pid]/press"])
      });
    }
  